import logo from "./logo-img.png";
import styles from "./Logo.module.css";

const Logo = () => {
  return <img src={logo} />;
};

export default Logo;
